import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      calendarContainer: {
        background: 'white',
        borderRadius: '8px',
        height: '975px',
        width: '1078px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        padding: '8px 0px 0px 0px',
        color: '#2A2A2A',
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('lg')]: {
          width: '1010px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '1020px',
          width: '1010px'
        }
      },
      calendarCurrentView: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        flex: '0 1 auto',
        justifyContent: 'space-between',
        height: '700px',
        background: 'transparent',
        margin: '0px 56px 8px 56px',
        [theme.breakpoints.down('lg')]: {
          width: '1010px',
          margin: '0px 10px 8px 10px',
          padding: '0px 28px 0px 28px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '675px'
        }
      },
      calendarButtons: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        flex: '0 1 auto',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '800px',
        background: 'transparent',
        padding: '0px 0px 0px 4px',
        [theme.breakpoints.down('lg')]: {
          position: 'relative',
          right: '562px',
          top: '54px'
        },
        [theme.breakpoints.only('lg')]: {
          top: '0px'
        }
      },
      calenderTitle: {
        fontSize: '32px',
        fontWeight: 600,
        fontFamily: props.fontFamily,
        margin: '0px',
        [theme.breakpoints.only('lg')]: {
          fontSize: '42px'
        }
      },
      calendarHeaderBox: {
        flex: '1 1 0%',
        maxHeight: '160px',
        background: 'transparent',
        padding: '0px 64px 0px 64px',
        [theme.breakpoints.only('lg')]: {
          maxHeight: '80px'
        }
      },
      disabledPreviousButton: {
        '&.Mui-disabled': {
          background: color.BORDER,
          color: color.DARK_GRAY
        }
      }
    })
  );
